<template>
  <div class="specials__special-boxes">
    <SpecialBox
      v-for="special in specials"
      :key="special.id"
      :special-id="special.id"
      :special-title="special.title"
      :started-at="special.startedAt"
      :image-url="special.imageUrl"
    />
  </div>
</template>
<script>
import SpecialBox from './SpecialBox'
export default {
  components: { SpecialBox },
  props: {
    specials: {
      type: Array,
      required: true
    }
  }
}
</script>
